import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CategoryService } from 'src/app/services/category.service';
import { CommonService } from 'src/app/services/common.service';
import { MembershipService } from 'src/app/services/membership.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-academymembership',
  templateUrl: './add-academymembership.component.html',
  styleUrls: ['./add-academymembership.component.scss'],
  providers: [MessageService]
})

export class AddAcademymembershipComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string;
  academyMembershipForm: FormGroup;
  submitted: boolean = false;
  currencyList: any;
  sportTypeList: any;
  membershipTypes: { name: string; value: string; }[];

  constructor(private formBuilder: FormBuilder, private router: Router, private membershipService: MembershipService, private categoryService: CategoryService,
    private messageService: MessageService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.pagetitle = 'Add Membership';
    this.membershipTypes = [
      { name:'Academy', value: 'academy'},
      { name: 'User', value: 'user'}
    ];

    this.academyMembershipForm = this.formBuilder.group({
      membershipType: [null, [Validators.required]],
      sport: [null, [Validators.required]],
      planName: ['', [Validators.required]],
      currency: [{name: "INR", currency_symbol: "₹"}, [Validators.required]],
      price: [null, [Validators.required]],
      benefit: this.formBuilder.array([
        this.benefitFormGroup()
      ]),
      duration: [null, [Validators.required]],
      discountPrice: [null,[Validators.required]],
      status: [true]
    })

    this.getSportTypeList();
    this.getCurrencyList();
  }

  getSportTypeList() {
    const query = `?filterByDisable=false&getSubcategory=true&filterByParentCategory=Sport`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.sportTypeList = data.data.items;
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
    })
  }

  getCurrencyList() {
    this.commonService.getCurrencyList().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.currencyList = data.data.items;
    })
  }

  get benefitsFormArray(): FormArray {
    return this.academyMembershipForm.get('benefit') as FormArray;
  }

  benefitFormGroup() {
    return this.formBuilder.group({
      key: ['', [Validators.required]],
      value: ['', [Validators.required]]
    })
  }

  addBenefit() {
    this.benefitsFormArray.push(this.benefitFormGroup());
  }

  removeBenefit(index:number) {
    this.benefitsFormArray.removeAt(index);
  }

  get f() {
    return this.academyMembershipForm.controls;
  }

  g(i:number) { 
    return this.academyMembershipForm.controls['benefit']['controls'][i]['controls'];
  }

  onSelectAcademyMembershipType(event) {
    this.academyMembershipForm.get('sport').setValidators((event.value === 'academy') ? [Validators.required] : null);
    this.academyMembershipForm.get('sport').updateValueAndValidity();
  }

  onSubmit() {
    this.submitted = true;
    let academyMembershipFormData = JSON.parse(JSON.stringify(this.academyMembershipForm.value));

    if (this.academyMembershipForm.invalid) {
      return;
    }

    academyMembershipFormData['currency'] = this.academyMembershipForm.value['currency']['name'];
    academyMembershipFormData['currencySymbols'] = this.academyMembershipForm.value['currency']['currency_symbol'];

    academyMembershipFormData = JSON.stringify(academyMembershipFormData, null, 4);
    this.membershipService.addMembership(academyMembershipFormData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'New Membership Added', life: 6000 });
      setTimeout(() => {
        this.router.navigate(['/manage/membership']);
      }, 2000);
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  backLink() {
    this.router.navigate(['/manage/membership']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

